// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"122":"20182b22966f9c96","5544":"104a6078547d513f"}[chunkId] + ".css";
};